import TransactionsTableView from './TransactionsTableView'

export default TransactionsTableView

